import { Routes } from '../constants';

/*
  TODO refactor this to use a variable for the
  walker id, name and photo in localStorage to determine
  if the user is in a direct booking flow.
*/
export const isInEmbed = window.location.pathname.includes(Routes.Embed);
export const useIsInEmbed = () => isInEmbed;
